import React from "react";
import { BrokerBoxAd } from "@bloomberg/media-ui-ads";

import styles from "./styles.module.css";

const options = {
    targeting: {
        position: "brokerboxarticle1",
    },
};

const BrokerBoxArticleAd = () => (
    <BrokerBoxAd
        className={styles.brokerBoxArticleAd}
        adOptions={options}
        hideEmptyAd
        v2
    />
);

export default BrokerBoxArticleAd;
